'use strict';

/** @type {import('./type')} */
module.exports = TypeError;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/es-errors/type.js
// module id = ../../../../es-errors/type.js
// module chunks = 5